export default __webpack_public_path__ + "static/media/intro1.942587ff.mp3";